import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { LoaderService } from '../../shared/services/loader.service';
export const InterceptorSkipLoader= 'X-Skip-Interceptor';
export const InterceptorSkipLoader_fromWidget= 'Widget-Skip-Interceptor';


@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
    constructor(public loaderService: LoaderService) { }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const hasSkipLoaderHeader =
            req.headers.has(InterceptorSkipLoader) ||
            req.headers.has(InterceptorSkipLoader_fromWidget);

        if (hasSkipLoaderHeader) {
            const headers = req.headers
                .delete(InterceptorSkipLoader)
                .delete(InterceptorSkipLoader_fromWidget);

            return next.handle(req.clone({ headers }));
        }

        this.loaderService.requestStarted();
        return next.handle(req).pipe(
            finalize(() => this.loaderService.requestEnded())
        );
    }
}
